import { render } from "./component-egrul-termination-date.vue?vue&type=template&id=38908d91"
import script from "./component-egrul-termination-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-termination-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-termination-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38908d91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38908d91', __exports__)) {
    api.reload('38908d91', __exports__)
  }
  
  module.hot.accept("./component-egrul-termination-date.vue?vue&type=template&id=38908d91", () => {
    api.rerender('38908d91', render)
  })

}


export default __exports__